module.exports = __webpack_public_path__ + "media/cameraShutter.275dc0e5.mp3";